import { shopOwnerRepo } from '../repo/shopOwnerRepo';

export const shopOwnerService = {
    async getAll(params = {}) {
        try {
            const response = await shopOwnerRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(shopOwnerId) {
        if (!shopOwnerId) {
            throw new Error('Shop owner ID is required');
        }
        try {
            const response = await shopOwnerRepo.getById(shopOwnerId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopOwnerRepo.getByShop(shopId, params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getTotalByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopOwnerRepo.getTotalByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getAvailableOwners(params = {}) {
        if (!params.shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopOwnerRepo.getAvailableOwners(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.shopId) {
            throw new Error('Shop ID is required');
        }
        if (!data.username) {
            throw new Error('Username is required');
        }

        try {
            const response = await shopOwnerRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(shopOwnerId, data) {
        if (!shopOwnerId) {
            throw new Error('Shop owner ID is required');
        }

        try {
            const response = await shopOwnerRepo.update(shopOwnerId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(shopOwnerId) {
        if (!shopOwnerId) {
            throw new Error('Shop owner ID is required');
        }

        try {
            const response = await shopOwnerRepo.toggleStatus(shopOwnerId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async setStatus(shopOwnerId, status) {
        if (!shopOwnerId) {
            throw new Error('Shop owner ID is required');
        }
        if (!['active', 'inactive'].includes(status)) {
            throw new Error('Status must be "active" or "inactive"');
        }
        try {
            const response = await shopOwnerRepo.setStatus(shopOwnerId, status);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats(shopId) {
        try {
            const response = await this.getTotalByShop(shopId);
            return response.data?.data || {
                total_owners: 0,
                active_owners: 0,
                inactive_owners: 0
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getOwnersByShopWithDetails(shopId, params = {}) {
        try {
            const response = await this.getByShop(shopId, params);
            const owners = response.data?.data || [];
            return {
                owners,
                total: owners.length,
                active: owners.filter(o => o.status === 'active').length,
                inactive: owners.filter(o => o.status === 'inactive').length,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getOwnerByUsername(username) {
        if (!username) {
            throw new Error('Username is required');
        }
        try {
            const response = await shopOwnerRepo.getAll({ search: username, per_page: 1 });
            const owners = response.data?.data || [];
            return owners.length > 0 ? owners[0] : null;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('ShopOwnerService Error:', error);
        return error.response?.data || error;
    },
};